/* tslint:disable */
/* eslint-disable */
/**
 * Swagger LogisticProcess - OpenAPI 3.0
 * Team of the warehouse
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface ErrorNotFoundResponse {
    'message'?: string;
}
export interface MessageResponse {
    'message'?: string;
}
export interface TeamRequest {
    'id'?: number;
    'sapStructureNumber'?: string;
    'name'?: string;
    'description'?: string;
    'uuid'?: string;
    'siteId'?: number;
}
export interface TeamResponse {
    'id': number;
    'name': string;
    'description': string;
    'uuid'?: string;
    'sapStructureNumber'?: string;
}

/**
 * TeamsApi - axios parameter creator
 */
export const TeamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create team manually
         * @summary Create team
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamManually: async (teamRequest: TeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamRequest' is not null or undefined
            assertParamExists('createTeamManually', 'teamRequest', teamRequest)
            const localVarPath = `/v1/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete team
         * @summary Delete team by Id
         * @param {number} id Id from team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTeamById', 'id', id)
            const localVarPath = `/v1/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get All teams of the warehouse
         * @summary Get All teams of the warehouse
         * @param {string} siteCode name os the siteCode
         * @param {boolean} enabled Team isEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTeamsBySiteCode: async (siteCode: string, enabled: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteCode' is not null or undefined
            assertParamExists('getAllTeamsBySiteCode', 'siteCode', siteCode)
            // verify required parameter 'enabled' is not null or undefined
            assertParamExists('getAllTeamsBySiteCode', 'enabled', enabled)
            const localVarPath = `/v1/teams/{site_code}`
                .replace(`{${"site_code"}}`, encodeURIComponent(String(siteCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all teams Active By site (Eplanning)
         * @summary Get all teams Active By site (Eplanning)
         * @param {string} siteCode Code of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTeamsBySiteFromProvider: async (siteCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteCode' is not null or undefined
            assertParamExists('getAllTeamsBySiteFromProvider', 'siteCode', siteCode)
            const localVarPath = `/v1/teams/provider/{site_code}`
                .replace(`{${"site_code"}}`, encodeURIComponent(String(siteCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update team manually
         * @summary Update team
         * @param {number} id Id from team
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: async (id: number, teamRequest: TeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTeam', 'id', id)
            // verify required parameter 'teamRequest' is not null or undefined
            assertParamExists('updateTeam', 'teamRequest', teamRequest)
            const localVarPath = `/v1/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamsApi - functional programming interface
 */
export const TeamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create team manually
         * @summary Create team
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamManually(teamRequest: TeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamManually(teamRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.createTeamManually']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete team
         * @summary Delete team by Id
         * @param {number} id Id from team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.deleteTeamById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get All teams of the warehouse
         * @summary Get All teams of the warehouse
         * @param {string} siteCode name os the siteCode
         * @param {boolean} enabled Team isEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTeamsBySiteCode(siteCode: string, enabled: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTeamsBySiteCode(siteCode, enabled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.getAllTeamsBySiteCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all teams Active By site (Eplanning)
         * @summary Get all teams Active By site (Eplanning)
         * @param {string} siteCode Code of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTeamsBySiteFromProvider(siteCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTeamsBySiteFromProvider(siteCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.getAllTeamsBySiteFromProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update team manually
         * @summary Update team
         * @param {number} id Id from team
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeam(id: number, teamRequest: TeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeam(id, teamRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.updateTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamsApi - factory interface
 */
export const TeamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamsApiFp(configuration)
    return {
        /**
         * Create team manually
         * @summary Create team
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamManually(teamRequest: TeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.createTeamManually(teamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete team
         * @summary Delete team by Id
         * @param {number} id Id from team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.deleteTeamById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get All teams of the warehouse
         * @summary Get All teams of the warehouse
         * @param {string} siteCode name os the siteCode
         * @param {boolean} enabled Team isEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTeamsBySiteCode(siteCode: string, enabled: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<TeamResponse>> {
            return localVarFp.getAllTeamsBySiteCode(siteCode, enabled, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all teams Active By site (Eplanning)
         * @summary Get all teams Active By site (Eplanning)
         * @param {string} siteCode Code of the site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTeamsBySiteFromProvider(siteCode: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TeamResponse>> {
            return localVarFp.getAllTeamsBySiteFromProvider(siteCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Update team manually
         * @summary Update team
         * @param {number} id Id from team
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(id: number, teamRequest: TeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.updateTeam(id, teamRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamsApi - object-oriented interface
 */
export class TeamsApi extends BaseAPI {
    /**
     * Create team manually
     * @summary Create team
     * @param {TeamRequest} teamRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTeamManually(teamRequest: TeamRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).createTeamManually(teamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete team
     * @summary Delete team by Id
     * @param {number} id Id from team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTeamById(id: number, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).deleteTeamById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get All teams of the warehouse
     * @summary Get All teams of the warehouse
     * @param {string} siteCode name os the siteCode
     * @param {boolean} enabled Team isEnabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllTeamsBySiteCode(siteCode: string, enabled: boolean, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getAllTeamsBySiteCode(siteCode, enabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all teams Active By site (Eplanning)
     * @summary Get all teams Active By site (Eplanning)
     * @param {string} siteCode Code of the site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllTeamsBySiteFromProvider(siteCode: string, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getAllTeamsBySiteFromProvider(siteCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update team manually
     * @summary Update team
     * @param {number} id Id from team
     * @param {TeamRequest} teamRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTeam(id: number, teamRequest: TeamRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).updateTeam(id, teamRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



